import { GridCell } from "../../../types/grid";
import { RESOURCE_TYPES } from "../../../types/resource";
import { GatherResourceTaskList, TASKS, Unit } from "../../../types/unit";

export function GetResourceType(Cell: GridCell) {

    let oreCell = Cell.properties.find(obj => {
        return Number(obj) === RESOURCE_TYPES.ORE;
    });

    let timberCell = Cell.properties.find(obj => {
        return Number(obj) === RESOURCE_TYPES.TIMBER;
    });

    if (oreCell !== undefined) {
        return Number(oreCell);
    }
    else if (timberCell !== undefined) {
        return Number(timberCell);
    }

    return 0;
}

export function SetNewGatherTaskList(Unit: Unit) {

    if (Unit.taskStack.length === 0) {
        Unit.taskStack = Unit.taskStack.concat(GatherResourceTaskList);
        return Unit.taskStack;
    }

    for (let i = Unit.taskStack.length - 1; i > 0; i--) {

        if (Unit.taskStack[i] === TASKS.DEPOSIT_RESOURCE) {
            Unit.taskStack.pop();
            Unit.taskStack = Unit.taskStack.concat(GatherResourceTaskList);
            return Unit.taskStack;
        }

        Unit.taskStack.pop();
    }

    return Unit.taskStack;
}